import React from "react";
import { Link } from "react-router-dom";
import "./History.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";

function History() {
  return (
    <div>
      <Header />

      <div className="container">
        <img src="/assets/images/sub/sub01.jpg" alt="" className="mainImg" />
        <div className="innerTop">
          <div className="subTitle">
            <h2>회사소개</h2>
            <h1>
              일상을 환하게,
              <br />
              공간을 특별하게
            </h1>
          </div>
          <div className="menuNav">
            <FontAwesomeIcon icon={faHouse} className="faHouse" />
            <span>/</span>
            <h2>회사소개</h2>
            <span>/</span>
            <h2>연혁</h2>
          </div>
        </div>
      </div>
      <div className="menuBar historyMenuBar">
        <Link to="/about" className="aboutMenu">
          <h2>회사소개</h2>
        </Link>
        <Link to="/history" className="historyMenu">
          <h2>연혁</h2>
        </Link>
        <Link to="/contact" className="contactMenu">
          <h2>찾아오시는 길</h2>
        </Link>
      </div>

      <div className="contentInner contentInnerOther">
        <div className="topText">
          <h1>
            어제보다 오늘,
            <br />
            오늘보다 내일 더 성장하는
          </h1>
          <h2>
            지속적인 성장 속에서도 느슨함 없이 더욱 발전된 모습을 유지하며 많은
            이들의 만족을 실현하기 위해 최선을 다하겠습니다.
          </h2>
        </div>
        <div className="historyContent">
          <div>
            <div>
              <h2>2018</h2>
              <h2>|</h2>
              <h2>2019</h2>
            </div>
            <div className="contentText">
              <p>주식회사 한국미광 설립</p>
              <p>공장 등록</p>
              <p>직접생산확인 증명서 획득 (옥외조명및설비)</p>
              <p>직접생산확인 증명서 획득 (배전,조정장치및액세서리)</p>
              <p>경쟁입찰참가자격 등록증 취득</p>
            </div>
            <img src="/assets/images/sub/history01.jpg" alt="" />
          </div>
          <div>
            <div>
              <h2>2020</h2>
              <h2>|</h2>
              <h2>2023</h2>
            </div>
            <div className="contentText">
              <p>방송통신기자재등의 적합등록 필증</p>
              <p>고효율에너지기자재 인증서 취득</p>
              <p>여성기업 확인서 취득</p>
              <p>디자인연구소 설립</p>
              <p>투광등, 논슬립, 브라켓 디자인 등록</p>
              <p>연구개발전담부서 설립</p>
              <p>경영혁신형 중소기업 확인서 취득</p>
              <p>벤처기업 등록</p>
            </div>
            <img src="/assets/images/sub/history02.jpg" alt="" />
          </div>
          <div>
            <div>
              <h2>2024</h2>
            </div>
            <div className="contentText">
              <p>비디오물제작업 등록</p>
              <p>전기공사업 등록</p>
              <p>산업디자인전문회사 등록</p>
              <p>마감 캡 디자인 등록</p>
            </div>
            <img src="/assets/images/sub/history03.jpg" alt="" />
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  );
}

export default History;
